export enum Permission {
    View = 0,
    Create = 1,
    Edit = 2,
    Delete = 3
}

export enum PermissionObject {
    Roles = 'Permission_Roles',
    Groups = 'Permission_Groups',
    Contacts = 'Contacts',
    News = 'News',
    Articles = 'Articles',
    Resources = 'Resources',
    Directories = 'Directories',
    Registration = 'Registration'
}

export enum PermissionObjectOperation {
    View = 'permissionView',
    Create = 'permissionCreate',
    Edit = 'permissionEdit',
    Delete = 'permissionDelete'
}


// WEBPACK FOOTER //
// ./common/enums/permissions.ts